import ActionTypes from "../constants";
import { UserInfoType, ViewportType } from "../containers/App/types";
import { ErrResponseType, ErrorDataType } from "../containers/Common/ErrorHandler/types";

// global actions
export const fetchStart = () => ({
  type: ActionTypes.FETCH_START
});
export const fetchEnd = () => ({
  type: ActionTypes.FETCH_END
});

export const resetError = () => ({
  type: ActionTypes.RESET_ERROR
});

export const updateViewport = (viewport: ViewportType) => ({
  type: ActionTypes.UPDATE_VIEWPORT,
  viewport
});

export const errorOccured = (err: ErrorDataType) => ({
  type: ActionTypes.ERROR_OCCURED,
  err
});
export const silentErrorOccured = (err: ErrorDataType) => ({
  type: ActionTypes.SILENT_ERROR_OCCURED,
  err
});

export const networkErrorOccured = (err: ErrorDataType) => ({
  type: ActionTypes.NETWORK_ERROR_OCCURED,
  err
});

export interface SetUserInfoActionType {
  type: typeof ActionTypes.SET_USER_INFO;
  userInfo: UserInfoType;
}

export const setUserInfo = (userInfo: UserInfoType): SetUserInfoActionType => ({
  type: ActionTypes.SET_USER_INFO,
  userInfo
});

export const setMenuKey = (menuKey: string) => ({
  type: ActionTypes.SET_MENU_KEY,
  menuKey
});
